// Builds the evidence detail path, encoding the originating case as a `case`
// query param. Carrying the origin in the URL (instead of ephemeral router
// location state) keeps the breadcrumb and back link correct across sub-tab
// switches, parent to child navigation, refreshes, and shared links. When no
// caseId is provided the link resolves to the global evidence ("Evidence") mode.
export const evidenceDetailPath = (
  uuid: string,
  options: { activeTab?: string; caseId?: number | null; tab?: string } = {}
): string => {
  const { activeTab = "overview", caseId, tab } = options;

  const params = new URLSearchParams();
  if (tab) params.set("tab", tab);
  if (caseId != null) params.set("case", String(caseId));

  const query = params.toString();
  return `/evidence/${uuid}/${activeTab}${query ? `?${query}` : ""}`;
};

// Parses the originating case id from the URL search params. Returns undefined when
// there is no valid case origin, which puts the evidence detail page in global
// "Evidence" mode. Centralized so every reader applies the same validation.
export const caseIdFromSearchParams = (
  searchParams: URLSearchParams
): number | undefined => {
  const value = Number(searchParams.get("case"));
  return Number.isInteger(value) && value > 0 ? value : undefined;
};
